import { Grid } from '@chakra-ui/layout'
import { Box, Button as ChakraButton, Flex, Heading, SimpleGrid, Text, Textarea, useDisclosure, useToast } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { useEffect, useRef, useState } from 'react'
import { BiSolidPaperPlane } from 'react-icons/bi'
import { FaFileSignature, FaPlus, FaTrash } from 'react-icons/fa'
import { HiOutlinePencilSquare } from 'react-icons/hi2'
import { MdArrowRight, MdBlock, MdOutlinePictureAsPdf } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { SelectCmp } from '../../../../components/SelectCmp'
import { ItensTabelaProps, TabelaItens } from '../../../../components/TabelaItens'
import { CriterioResponse, DescricaoCargo, Excluidos, iNomeId, iSolicitacaoReajuste, NivelColaborador, NivelCriterioResponse } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import DescricaoCargoPDF from '../../Individual/components/RelatorioPDF'
import { ModalAssinarDocumento } from '../Componentes/ModalAssinarDocumento'
import { ModalExcluirAtribuicao } from '../Componentes/ModalExcluirAtribuicao'
import { ModalExcluirCargoSupOuSub } from '../Componentes/ModalExcluirCargoSupOuSub'
import { ModalExcluirCompetencia } from '../Componentes/ModalExcluirCompentencia'
import { TabelaItensEditing } from '../Componentes/TabelaItensEditing'
export interface iPerfilColaboradorAssinante{
  nome: string
  email: string
  assinado: boolean
}

export const VisualizacaoSolicitacao: React.FC = () => {
  const [Cargo, setCargo] = useState<DescricaoCargo>()
  const [CargoOriginal, setCargoOriginal] = useState<DescricaoCargo | null>(null) // Apenas para verificar se um item excluido existe no original ou foi adicionado nessa edição
  const [Cargos, setCargos] = useState<DescricaoCargo[]>()
  const [Departamentos, setDepartamentos] = useState<iNomeId[]>([])

  const nav = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const itensTabelaAtribuicoes = itensPorCategoria(Cargo as DescricaoCargo, 'atribuicoes')
  const itensTabelaConhecimentosTecnicos = itensPorCategoria(Cargo as DescricaoCargo, 'conhecimentosTecnicos')
  const [Criterios, setCriterios] = useState<CriterioResponse[]>([])
  const [isEditing, setIsEditing] = useState(false)
  const [isSubmittingAjuste, setIsSubmittingAjuste] = useState(false)
  const toast = useToast()
  const { onClose, isOpen, onOpen } = useDisclosure()
  const [baixarRelatorio, setBaixarRelatorio] = useState(false)
  const [indiceDoExcluido, setIndiceDoExcluido] = useState<number>()
  const [nomeExcluido, setNomeExcluido] = useState<string>('')
  const [nivelDoExcluido, setNivelDoExcluido] = useState<NivelColaborador>({
    atribuicoes: [],
    competenciasComportamentais: [],
    conhecimentosTecnicos: [],
    habilidades: [],
    criteriosPontuacao: [],
    mediana: 0,
    media: 0,
    primeiroQuartil: 0,
    terceiroQuartil: 0
  })

  const [dadosAssinante, setDadosAssinante] = useState<Partial<iPerfilColaboradorAssinante>>()

  const [solicitacoesDoAssinante, setSolicitacoesDoAssinante] = useState<iSolicitacaoReajuste[]>([])

  const [indexDoCargoExcluido, setIndiceDoCargoExcluido] = useState<number>(0)

  const modalB = useDisclosure()
  const modalC = useDisclosure()
  const modalD = useDisclosure()
  const modalE = useDisclosure()
  const modalF = useDisclosure()

  const cargosSuperioresIDs = Cargo?.cargosSuperiores?.map(cs => cs.cargoSuperiorId) ?? []

  const cargosSuperiores = Cargos?.filter(c => cargosSuperioresIDs.includes(c.id)) ?? []

  const { documentoId } = useParams()
  const codigo = localStorage.getItem(`codigo-assinatura-cargosESalarios-${documentoId ?? ''}`)

  const criarSolicitacaoReajuste = (
    cargo: DescricaoCargo
  ): iSolicitacaoReajuste => ({
    missao: cargo.missao ?? '',
    trilhasDeCarreira: cargo.trilhasDeCarreira ?? [],
    cargosSuperiores: cargo.cargosSuperiores ?? [],
    niveis: {},
    competenciasComportamentais: cargo.competenciasComportamentais ?? [],
    observacoes: '',
    excluidosMotivos: [],
    statusSolicitacao: 1,
    codigoSolicitante: '0000000',
    emailSolicitante: '',
    solicitacaoId: undefined
  })

  const registrarExclusaoNaUltimaSolicitacao = (excluido: Excluidos): void => {
    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      const solicitacaoReajustes = [
        ...(cargoAtual.solicitacaoReajustes ?? [])
      ]

      if (solicitacaoReajustes.length === 0) {
        return cargoAtual
      }

      const ultimoIndex = solicitacaoReajustes.length - 1
      const ultimaSolicitacao = solicitacaoReajustes[ultimoIndex]

      solicitacaoReajustes[ultimoIndex] = {
        ...ultimaSolicitacao,
        excluidosMotivos: [
          ...(ultimaSolicitacao.excluidosMotivos ?? []),
          excluido
        ]
      }

      return {
        ...cargoAtual,
        solicitacaoReajustes
      }
    })
  }

  function opeModalExcluirCargoSupOuSub(index: number, cargoSuperior: boolean): void {
    setIndiceDoCargoExcluido(index)
    if (cargoSuperior) {
      modalE.onOpen()
    } else {
      modalF.onOpen()
    }
  }

  function handleTrilhaChange(index: number, field: 'areaId' | 'cargoSuperiorId', value: string): void {
    if (!Cargo) return
    const updated = [...Cargo.trilhasDeCarreira]
    updated[index] = { ...updated[index], [field]: value }

    if (field === 'cargoSuperiorId') {
      updated[index].cargoSuperiorNome = Cargos?.find(c => c.id === value)?.nomeCargo
    }

    if (field === 'areaId') {
      updated[index].areaNome = Departamentos.find(d => d.id === value)?.nome
      // Cargo escolhido antes pode nao pertencer mais a nova area
      updated[index].cargoSuperiorId = ''
      updated[index].cargoSuperiorNome = undefined
    }

    setCargo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        trilhasDeCarreira: updated
      }
    })
  }

  function handleCargoSupChange(index: number, field: 'cargoSuperiorId', value: string): void {
    if (!Cargo?.cargosSuperiores) return
    const updated = [...Cargo.cargosSuperiores]
    updated[index] = { ...updated[index], [field]: value }

    if (field === 'cargoSuperiorId') {
      updated[index].nome = Cargos?.find(c => c.id === value)?.nomeCargo
    }

    setCargo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        cargosSuperiores: updated
      }
    })
  }

  function removeTrilha(index: number, motivoExclusao: string): void {
    const trilhaExcluida = Cargo?.trilhasDeCarreira?.[index]

    setCargo(prev => {
      if (!prev) return prev

      return {
        ...prev,
        trilhasDeCarreira: prev.trilhasDeCarreira.filter((_, i) => i !== index)
      }
    })

    const existeNoOriginal =
    !!trilhaExcluida &&
    CargoOriginal?.trilhasDeCarreira?.some(
      trilha => trilha.cargoSuperiorId === trilhaExcluida.cargoSuperiorId
    )

    if (existeNoOriginal) {
      registrarExclusaoNaUltimaSolicitacao({
        motivoExclusao,
        campoExcluido: `trilhasDeCarreira[${index}]`,
        tipoItem: 1,
        aceito: null
      })
    }

    modalF.onClose()
  }

  function removeCargoSup(index: number, motivoExclusao: string): void {
    const cargoSuperiorExcluido = Cargo?.cargosSuperiores?.[index]

    setCargo(prev => {
      if (!prev) return prev

      return {
        ...prev,
        cargosSuperiores: prev.cargosSuperiores?.filter((_, i) => i !== index)
      }
    })

    const existeNoOriginal =
    !!cargoSuperiorExcluido &&
    CargoOriginal?.cargosSuperiores?.some(
      cargo => cargo.nome === cargoSuperiorExcluido.nome
    )

    if (existeNoOriginal) {
      registrarExclusaoNaUltimaSolicitacao({
        motivoExclusao,
        campoExcluido: `cargosSuperiores[${index}]`,
        tipoItem: 0,
        aceito: null
      })
    }

    modalE.onClose()
  }

  function addTrilha(): void {
    setCargo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        trilhasDeCarreira: [...prev.trilhasDeCarreira, { areaId: '', cargoSuperiorId: '' }]
      }
    })
  }

  function addCargoSup(): void {
    setCargo(prev => {
      if (!prev) return prev

      return {
        ...prev,
        cargosSuperiores: [
          ...(prev.cargosSuperiores ?? []),
          { cargoSuperiorId: '' }
        ]
      }
    })
  }

  function GetDescritivos(): void {
    setIsLoading(true)

    const request = {
      id: documentoId,
      codigo: codigo
    }
    appApi.post('api/CargosESalarios/GetListByCode?popularColabs=false', request)
      .then((res) => {
        if (res.data.length === 0) {
          setCargos(undefined)
        } else {
          setCargos(res.data)
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function GetDepartamentos(): void {
    const request = {
      id: documentoId,
      codigo: codigo
    }
    appApi.post('api/CargosESalarios/GetDepartamentosByCode', request)
      .then((res) => setDepartamentos(res.data))
      .catch(err => console.log(err))
  }

  function OpenModalExclusaoByAtribuicoes(nivel: NivelColaborador, nivelNome: string, idx: number): void {
    setNivelDoExcluido(nivel)
    setNomeExcluido(nivelNome)
    setIndiceDoExcluido(idx)
    modalC.onOpen()
  }

  function OpenModalExclusaoByRequisitosTecnicos(nivel: NivelColaborador, nivelNome: string, idx: number): void {
    setNivelDoExcluido(nivel)
    setNomeExcluido(nivelNome)
    setIndiceDoExcluido(idx)
    modalD.onOpen()
  }

  function excluirRequisitoTecnico(
    nivel: NivelColaborador,
    nivelNome: string,
    idx: number,
    motivoExclusao: string
  ): void {
    const requisitoTecnicoExcluido =
    Cargo?.niveis?.[nivelNome]?.conhecimentosTecnicos?.[idx]

    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      const nivelAtual = cargoAtual.niveis[nivelNome]

      if (!nivelAtual) return cargoAtual

      const novos = [...(nivelAtual.conhecimentosTecnicos ?? [])]
      novos.splice(idx, 1)

      return {
        ...cargoAtual,
        niveis: {
          ...cargoAtual.niveis,
          [nivelNome]: {
            ...nivelAtual,
            conhecimentosTecnicos: novos
          }
        }
      }
    })

    const existeNoOriginal =
    !!requisitoTecnicoExcluido &&
    CargoOriginal?.niveis?.[nivelNome]?.conhecimentosTecnicos?.includes(
      requisitoTecnicoExcluido
    )

    if (existeNoOriginal) {
      registrarExclusaoNaUltimaSolicitacao({
        motivoExclusao,
        campoExcluido: `niveis[${nivelNome}].conhecimentosTecnicos[${idx}]`,
        tipoItem: 4,
        aceito: null
      })
    }

    modalD.onClose()
  }

  function excluirAtribuicao(
    nivel: NivelColaborador,
    nivelNome: string,
    idx: number,
    motivoExclusao: string
  ): void {
    const atribuicaoExcluida =
    Cargo?.niveis?.[nivelNome]?.atribuicoes?.[idx]

    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      const nivelAtual = cargoAtual.niveis[nivelNome]

      if (!nivelAtual) return cargoAtual

      const novos = [...(nivelAtual.atribuicoes ?? [])]
      novos.splice(idx, 1)

      return {
        ...cargoAtual,
        niveis: {
          ...cargoAtual.niveis,
          [nivelNome]: {
            ...nivelAtual,
            atribuicoes: novos
          }
        }
      }
    })

    const existeNoOriginal =
    !!atribuicaoExcluida &&
    CargoOriginal?.niveis?.[nivelNome]?.atribuicoes?.includes(atribuicaoExcluida)

    if (existeNoOriginal) {
      registrarExclusaoNaUltimaSolicitacao({
        motivoExclusao,
        campoExcluido: `niveis[${nivelNome}].atribuicoes[${idx}]`,
        tipoItem: 3,
        aceito: null
      })
    }

    modalC.onClose()
  }

  function OpenModalExclusao(i: number): void {
    setIndiceDoExcluido(i)
    modalB.onOpen()
  }

  function excluirCompetencia(i: number, motivoExclusao: string): void {
    const competenciaExcluida = Cargo?.competenciasComportamentais?.[i]

    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      const novos = [...(cargoAtual.competenciasComportamentais ?? [])]

      novos.splice(i, 1)

      return {
        ...cargoAtual,
        competenciasComportamentais: novos
      }
    })

    const existeNoOriginal =
    !!competenciaExcluida &&
    CargoOriginal?.competenciasComportamentais?.includes(competenciaExcluida)

    if (existeNoOriginal) {
      registrarExclusaoNaUltimaSolicitacao({
        motivoExclusao,
        campoExcluido: `competenciasComportamentais[${i}]`,
        tipoItem: 5,
        aceito: null
      })
    }

    modalB.onClose()
  }

  function setMissao(newMissao: string): void {
    setCargo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        missao: newMissao
      }
    })
  }

  function cancelarAjustes(): void {
    setIsEditing(false)
  }

  function editarDoc(): void {
    setIsEditing(!isEditing)
    if (!isEditing) {
      toast({
        position: 'top',
        title: 'Você entrou no modo edição',
        status: 'warning',
        duration: 3000
      })
    } else {
      toast({
        position: 'top',
        title: 'Você saiu do modo edição',
        status: 'warning',
        duration: 3000
      })
    }
  }

  function GetCriterios(): void {
    setIsLoading(true)

    const request = {
      id: documentoId,
      codigo: codigo
    }

    appApi.post('api/Criterios/GetCriteriosByCode', request)
      .then((res) => {
        setCriterios(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  type DicionarioNivel = Record<string, string[]>
  type CategoriaKey =
  | 'conhecimentosTecnicos'
  | 'habilidades'
  | 'atribuicoes'
  | 'competenciasComportamentais'

  function criarNivelVazio(): NivelColaborador {
    return {
      conhecimentosTecnicos: [''],
      habilidades: [''],
      atribuicoes: [''],
      competenciasComportamentais: [''],
      primeiroQuartil: 0,
      mediana: 0,
      media: 0,
      terceiroQuartil: 0,
      criteriosPontuacao: []
    }
  }

  function GetDescritivo(): void {
    setIsLoading(true)

    appApi.post('api/CargosESalarios/GetPorIdAndCode', { Id: documentoId, codigo })
      .then((res) => {
        const data: DescricaoCargo = res.data

        if (Object.keys(data.niveis).length === 0) {
          let niveisGerados: Record<string, NivelColaborador> = {}

          if (data.tipoNivel === 'Júnior/Pleno/Sênior') {
            niveisGerados = {
              Júnior: criarNivelVazio(),
              Pleno: criarNivelVazio(),
              Sênior: criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II e III') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II, III, IV e V') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio(),
              'Nível IV': criarNivelVazio(),
              'Nível V': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'Único') {
            niveisGerados = {
              Único: criarNivelVazio()
            }
          }

          data.niveis = niveisGerados
        }

        setCargo(data)
        setCargoOriginal(data)
      })
      .catch((err) => {
        console.log(err)
        // Codigo invalido, expirado ou de um assinante ja excluido: sem isso a tela fica
        // em branco silenciosamente em vez de mandar de volta pra digitar o codigo de novo
        localStorage.removeItem(`codigo-assinatura-cargosESalarios-${documentoId ?? ''}`)
        nav(`/Descritivo/Assinatura/LinhaDoTempo/${documentoId ?? ''}`)
      })
      .finally(() => setIsLoading(false))
  }

  function itensPorCategoria(cargo: DescricaoCargo, categoria: CategoriaKey): ItensTabelaProps[] {
    if (!cargo?.niveis) return []

    const lista: DicionarioNivel[] = Object.entries(cargo.niveis).map(
      ([nomeNivel, nivel]) => ({
        [nomeNivel]: (nivel[categoria] ?? []).filter(Boolean)
      })
    )

    return [{ descricaoDicionario: lista }]
  }

  function onSolicitarReajuste(): void {
    if (!Cargo || isSubmittingAjuste) return

    // Trilha sem area nao passa na validacao do backend quando o admin aceita o pedido:
    // melhor barrar aqui, com uma mensagem clara, do que deixar o erro estourar la na frente
    if (Cargo.trilhasDeCarreira?.some(trilha => !trilha.areaId?.trim())) {
      toast({
        title: 'Selecione a área de todas as trilhas de carreira antes de enviar',
        duration: 4000,
        status: 'error',
        position: 'top'
      })
      return
    }

    setIsSubmittingAjuste(true)

    const guidVazio = '00000000-0000-0000-0000-000000000000'

    const objCargoPut = {
      ...Cargo,
      niveis: Object.fromEntries(
        Object.entries(Cargo.niveis).map(([key, nivel]) => [key.replaceAll(' ', '_'), nivel])
      ),
      cargosSuperiores: Cargo.cargosSuperiores ?? [],

      trilhasDeCarreira: Cargo.trilhasDeCarreira?.map((trilha) => ({
        ...trilha,
        areaId: trilha.areaId?.trim() ? trilha.areaId : guidVazio,
        cargoSuperiorId: trilha.cargoSuperiorId?.trim() ? trilha.cargoSuperiorId : guidVazio
      })) ?? [],

      solicitacaoReajustes: Cargo.solicitacaoReajustes?.map((solicitacao) => ({
        ...solicitacao,
        trilhasDeCarreira: solicitacao.trilhasDeCarreira?.map((trilha) => ({
          ...trilha,
          areaId: trilha.areaId?.trim() ? trilha.areaId : guidVazio,
          cargoSuperiorId: trilha.cargoSuperiorId?.trim() ? trilha.cargoSuperiorId : guidVazio
        })) ?? []
      })) ?? []

    } satisfies DescricaoCargo

    const objRequisitor = {
      Id: documentoId,
      Codigo: codigo
    }

    const request = {
      Input: objCargoPut,
      Requisitor: objRequisitor
    }

    appApi.put('api/CargosESalarios/UpdateByCode', request)
      .then((res) => {
        toast({
          title: 'Solicitação feita com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        setIsEditing(false)
        nav('/Descritivo/Assinatura/AjusteConfirmacao')
        // GetDescritivo()
      })
      .catch(err => {
        console.log(err)

        toast({
          title: 'Algo deu errado',
          duration: 4000,
          status: 'error',
          position: 'top'
        })
      })
      .finally(() => setIsSubmittingAjuste(false))
  }

  const alterarObservacoesUltimaSolicitacao = (observacoes: string): void => {
    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      const solicitacaoReajustes = [
        ...(cargoAtual.solicitacaoReajustes ?? [])
      ]

      if (solicitacaoReajustes.length === 0) {
        return cargoAtual
      }

      const ultimoIndex = solicitacaoReajustes.length - 1

      solicitacaoReajustes[ultimoIndex] = {
        ...solicitacaoReajustes[ultimoIndex],
        observacoes
      }

      return {
        ...cargoAtual,
        solicitacaoReajustes
      }
    })
  }

  const solicitacaoCriadaRef = useRef(false)

  useEffect(() => {
    if (!Cargo) return
    if (solicitacaoCriadaRef.current) return

    solicitacaoCriadaRef.current = true

    setCargo((cargoAtual) => {
      if (!cargoAtual) return cargoAtual

      return {
        ...cargoAtual,
        solicitacaoReajustes: [
          ...(cargoAtual.solicitacaoReajustes ?? []),
          criarSolicitacaoReajuste(cargoAtual)
        ]
      }
    })
  }, [Cargo?.id, isEditing])

  useEffect(() => {
    if (isEditing) return
    GetDescritivo()
    GetCriterios()
    GetDescritivos()
    GetDepartamentos()

    console.log(isLoading)
  }, [isEditing])

  useEffect(() => {
    if (baixarRelatorio) {
      setTimeout(() => {
        const botao: any = document.getElementById('botaoBaixarRelatorio')
        console.log(botao.href)
        const link = document.createElement('a')
        link.href = botao.href
        link.download = `Descricao_Cargo_e_Funcao_${Cargo?.nomeCargo.replaceAll(' ', '_')}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setBaixarRelatorio(false)
      }, 3000)
    }
  }, [baixarRelatorio])

  useEffect(() => {
    if (!Cargo || !dadosAssinante) return
    const solicitacaoDeReajuste = Cargo.solicitacaoReajustes ?? []

    const solicitacoesFiltradas = solicitacaoDeReajuste.filter(
      (solicitacao) => solicitacao.emailSolicitante === dadosAssinante?.email
    ).filter(solicitacao => solicitacao.statusSolicitacao === 1)

    setSolicitacoesDoAssinante(solicitacoesFiltradas)
  }, [Cargo, dadosAssinante])

  useEffect(() => {
    if (!dadosAssinante) return

    // console.log('Dados do assinante:', dadosAssinante)
    if (dadosAssinante.assinado) {
      nav(`/Descritivo/Assinatura/LinhaDoTempo/${documentoId}/AssinaturaConfirmacao`)
    }
  }, [dadosAssinante])

  return (
        <Flex bgColor={'white'} flex={1} flexDirection={'column'} display={'flex'} align={'center'} pb={'8rem'}>
          {baixarRelatorio && Cargo && (
            <PDFDownloadLink
              document={
                // Sem assinaturas de proposito: este PDF e so o conteudo escrito do cargo,
                // sem nenhuma assinatura (a tela nao tem a lista de assinaturas do documento)
                <DescricaoCargoPDF
                  cargo={Cargo}
                  criterios={Criterios}
                />
              }
              id='botaoBaixarRelatorio'
            >
              {() =>
                <Box pos={'absolute'}></Box>
              }
            </PDFDownloadLink>
          )}
         {!isEditing && (
             <>
          <Box display={'flex'} flexDirection={'row'} width={'100%'} justifyContent={'right'} h={'50px'} gap={4} pr={8} pt={5}>
              {/*    <ChakraButton
                borderRadius={'.25rem'}
                filter='auto'
                h={'40px'}
                fontSize={'14px'}
                py={'.125rem'}
                px={'.75rem'}
                color={'pink.200'}
                border={'1px solid var(--chakra-colors-pink-200)'}
                _hover={{
                  bg: 'var(--chakra-colors-pink-200)',
                  boxShadow: 'var(--SombraBtns)',
                  color: 'var(--c1)',
                  transition: 'var(--transitionBtns);'
                }}
                bg={'white'}
                leftIcon={<MdOutlinePictureAsPdf size={20} />}
                onClick={() => setBaixarRelatorio(true)}
                >Gerar PDF</ChakraButton> */}

                <ChakraButton
                borderRadius={'.25rem'}
                filter='auto'
                h={'40px'}
                fontSize={'14px'}
                py={'.125rem'}
                px={'.75rem'}
                color={'pink.200'}
                border={'1px solid var(--chakra-colors-pink-200)'}
                _hover={{
                  bg: 'var(--chakra-colors-pink-200)',
                  boxShadow: 'var(--SombraBtns)',
                  color: 'var(--c1)',
                  transition: 'var(--transitionBtns);'
                }}
                bg={'white'}
                leftIcon={<HiOutlinePencilSquare size={20} />}
                onClick={() => editarDoc()}
                >Solicitar ajustes no documento</ChakraButton>
            </Box>
            </>
         )}
            {solicitacoesDoAssinante.length > 0 && (
              <Heading color={'red.500'} mt={16}>Você tem {solicitacoesDoAssinante.length} solicitações de ajustes pendentes</Heading>
            )}
            <Heading mt={16}>{isEditing ? 'Ajustando documento' : Cargo?.nomeCargo}</Heading>
            {isEditing && (
              <Text mt={'1.5rem'} fontSize={'lg'} fontWeight={'medium'}>Edite as informações ou adicione os itens necessários. Em seguida suas alterações e observações serão enviadas para serem consolidadas e o <br/> documento será encaminhado novamente para assinatura </Text>
            )}
            <Box pt={'4'} pb={'4'} mt={8}>
               <Flex w={'1380px'} border={'2px solid var(--chakra-colors-gray-400)'} flexDirection={'column'} >
                  <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'} >
                      <Heading size={'md'}>Identificação</Heading>
                  </Box>
                  <SimpleGrid columns={3}>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>Título do cargo:</Text>
                        <Heading size={'md'}>{Cargo?.nomeCargo}</Heading>
                      </Flex>
                    </Box>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>Área:</Text>
                        <Heading size={'md'}>{Cargo?.areaNome ?? '-'}</Heading>
                      </Flex>
                    </Box>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>CBO:</Text>
                        <Heading size={'md'}>{Cargo?.cbo}</Heading>
                      </Flex>
                    </Box>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>Hierarquia:</Text>
                        <Heading size={'md'}>{Cargo?.nivelHierarquico}</Heading>
                      </Flex>
                    </Box>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>Atuação:</Text>
                        <Heading size={'md'}>{Cargo?.atuacao}</Heading>
                      </Flex>
                    </Box>
                    <Box border="1px solid" borderColor="gray.300" p={4}>
                      <Flex flexDirection={'column'}>
                        <Text>Cargo do superior imediato:</Text>
                        {!isEditing
                          ? (
                          <Box>
                            {cargosSuperiores.length > 0
                              ? (
                                  cargosSuperiores.map((cs, i) => {
                                    return (
                                      <Heading key={i} size={'md'}> {cs.nomeCargo} </Heading>
                                    )
                                  })
                                )
                              : (
                                  <Text>Ninguém (Topo da hierarquia)</Text>
                                )}
                          </Box>
                            )
                          : (
                          <Flex flexDir={'column'} alignItems={'end'} w={'100%'}>
                          {Cargo?.cargosSuperiores?.map((cargoSup, index) => {
                            return (
                              <Flex key={index} gap="1rem" align="flex-end" w={'100%'}>
                                <SelectCmp
                                  mb='8px'
                                  w="100%"
                                  title={`Cargo superior (${index + 1})`}
                                  placeholder="Selecione o cargo superior..."
                                  value={cargoSup.cargoSuperiorId}
                                  OnChange={(v) => handleCargoSupChange(index, 'cargoSuperiorId', v)}
                                >
                                  <option value="00000000-0000-0000-0000-000000000000">Ninguém (Topo da hierarquia)</option>
                                  {Cargos
                                    ?.map(c => (
                                      <option key={c.id} value={c.id}>{c.nomeCargo}</option>
                                    ))}
                                </SelectCmp>
                                {index > 0 && (
                                  <ButtonCmp VarColor="Red" mb='8px' onClick={() => opeModalExcluirCargoSupOuSub(index, true)}><FaTrash/></ButtonCmp>
                                )}
                              </Flex>
                            )
                          })}
                          <ButtonCmp VarColor="Green2" mt={'8px'} onClick={addCargoSup} w={'12rem'} leftIcon={<FaPlus/>}>Adicionar cargo superior</ButtonCmp>
                        </Flex>
                            )}
                      </Flex>
                    </Box>

                  </SimpleGrid>
                  <Box border="1px solid" borderColor="gray.300" p={4}>
                    <Flex flexDirection={'column'}>
                        <Text>Trilhas de carreira (próximo cargo por área):</Text>
                        {!isEditing
                          ? (
                            <>&nbsp;
                            </>
                            )
                          : (
                          <Flex flexDir={'column'} alignItems={'end'} w={'100%'}>
                          {Cargo?.trilhasDeCarreira.map((trilha, index) => {
                            return (
                              <Flex key={index} gap="1rem" align="flex-end" w={'100%'}>
                                <SelectCmp
                                  mb='8px'
                                  w="100%"
                                  title={`Área da trilha (${index + 1})`}
                                  placeholder="Selecione a área..."
                                  value={trilha.areaId}
                                  OnChange={(v) => handleTrilhaChange(index, 'areaId', v)}
                                >
                                  <option value="">Selecione a área...</option>
                                  {Departamentos
                                    ?.map(d => (
                                      <option key={d.id} value={d.id}>{d.nome}</option>
                                    ))}
                                </SelectCmp>
                                <SelectCmp
                                  mb='8px'
                                  w="100%"
                                  title={`Próximo cargo — trilha ${trilha.areaNome ?? `(${index + 1})`}`}
                                  placeholder="Selecione o cargo superior..."
                                  value={trilha.cargoSuperiorId}
                                  OnChange={(v) => handleTrilhaChange(index, 'cargoSuperiorId', v)}
                                >
                                  <option value="">Ninguém (Topo da hierarquia)</option>
                                  {Cargos
                                    // So cargos que tambem participam da mesma area da trilha selecionada,
                                    // e o mesmo proximo cargo nao pode se repetir em duas linhas
                                    ?.filter(c => trilha.areaId === '' || c.trilhasDeCarreira?.some(t => t.areaId === trilha.areaId))
                                    ?.filter(c => c.id === trilha.cargoSuperiorId || !Cargo.trilhasDeCarreira.some((outra, i) => i !== index && outra.cargoSuperiorId === c.id))
                                    ?.map(c => (
                                      <option key={c.id} value={c.id}>{c.nomeCargo}</option>
                                    ))}
                                </SelectCmp>
                                {index > 0 && (
                                  <ButtonCmp VarColor="Red" mb='8px' onClick={() => opeModalExcluirCargoSupOuSub(index, false)}><FaTrash/></ButtonCmp>
                                )}
                              </Flex>
                            )
                          })}
                          <ButtonCmp VarColor="Green2" mt={'38px'} onClick={addTrilha} w={'12rem'} leftIcon={<FaPlus/>}>Adicionar trilha de carreira</ButtonCmp>
                        </Flex>
                            )}

                             <Flex direction="column" gap=".5rem">
                      {Object.entries(Cargo?.cargosFuturos ?? {}).map(([trilha, cargos]) => (
                        <Flex key={trilha} gap=".25rem">
                           <Flex direction="column">
                             <Text fontWeight={'bold'} >{trilha}: </Text>
                          <Flex gap=".25rem" alignItems="center" flexWrap="wrap">
                            {cargos.map((cargoFuturo, idx) => (
                              <Flex key={idx} align="center" gap=".25rem" color="var(--Rosa)" fontWeight="600">
                                {idx > 0 && <MdArrowRight size={16} />}
                                <Text>{cargoFuturo.nome}</Text>
                              </Flex>
                            ))}
                          </Flex>
                            </Flex>
                        </Flex>
                      ))}
                    </Flex>
                      </Flex>
                  </Box>
                  <Box border="1px solid" borderColor="gray.300" p={4}>
                    <Flex flexDirection={'column'}>
                      <Text>Cargos subordinados:</Text>
                      {(Cargo?.cargosSubordinados?.length ?? 0) > 0
                        ? (
                          <Flex flexWrap="wrap" gap=".5rem" mt={1}>
                            {Cargo?.cargosSubordinados?.map((cs) => (
                              <Text key={cs.id} fontWeight={'600'} color={'var(--Rosa)'}>{cs.nome}</Text>
                            ))}
                          </Flex>
                          )
                        : (
                          <Text mt={1}>Ninguém (nenhum cargo subordinado)</Text>
                          )}
                    </Flex>
                  </Box>
                </Flex>
            </Box>
            {!isEditing
              ? (
              <>
                <TabelaItens tituloTabela={'Missão'} isTabelaDescricaoSimples descricaoSimples={Cargo?.missao} mt={8} />
                <TabelaItens tituloTabela={'Atribuições da Função'} itensTabela={itensTabelaAtribuicoes} mt={8} />
                <TabelaItens tituloTabela={'Conhecimentos técnicos e habilidades'} itensTabela={itensTabelaConhecimentosTecnicos} mt={8} />
                <TabelaItens tituloTabela={'Requisitos comportamentais'} isTabelaDescricaoSimples descricaoSimples={Cargo?.competenciasComportamentais?.join('\n')} whiteSpace="pre-line" mt={8} />
              </>
                )
              : (
                  <>
                <TabelaItensEditing tituloTabela={'Missão'} isTabelaDescricaoSimples descricaoSimples={Cargo?.missao} setMissao={setMissao} mt={8}></TabelaItensEditing>

                  {/* Atribuições */}
                  <Box display={'flex'} flexDirection={'column'} border={'2px solid var(--chakra-colors-gray-400)'} w={'1380px'} mt={8}>
                    <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'}>
                      <Heading size={'md'}>Atribuições da função</Heading>
                    </Box>
                    {Cargo != null &&
                    Object.entries(Cargo.niveis).map(([nivelNome, nivel]) => (
                      <>
                        <Flex flexDir="column">
                          <Box display={'flex'} flexDirection={'row'} border={'1px solid var(--chakra-colors-gray-400)'} w={'1378px'}>
                            <Text fontWeight="medium" display={'flex'} alignItems={'center'} backgroundColor={'gray.200'} maxWidth={'112px'} w={'112px'} p={4} justifyContent={'center'}>{nivelNome}</Text>
                            <Box w={'100%'} gap={'8px'} display={'flex'} flexDirection={'column'} p={4}>
                              {nivel.atribuicoes.map((atr, idx) => (
                                <InputCmp
                                  key={idx}
                                  value={atr.replaceAll('_', ' ')}
                                  OnChange={(val) => {
                                    const novos = [...nivel.atribuicoes]
                                    novos[idx] = val
                                    setCargo({
                                      ...Cargo,
                                      niveis: {
                                        ...Cargo.niveis,
                                        [nivelNome]: { ...nivel, atribuicoes: novos }
                                      }
                                    })
                                  }}
                                  OnRemove={
                                    nivel.atribuicoes.length > 1
                                      ? () => {
                                          OpenModalExclusaoByAtribuicoes(nivel, nivelNome, idx)
                                        }
                                      : undefined
                                          }
                                        />
                              ))}
                              <ButtonCmp
                                OutlineColor="Green2"
                                leftIcon={<FaPlus />}
                                w="16rem"
                                onClick={() => {
                                  setCargo({
                                    ...Cargo,
                                    niveis: {
                                      ...Cargo.niveis,
                                      [nivelNome]: {
                                        ...nivel,
                                        atribuicoes: [...nivel.atribuicoes, '']
                                      }
                                    }
                                  })
                                }}
                                >
                                Adicionar Atribuição
                                </ButtonCmp>
                            </Box>
                          </Box>
                          </Flex>
                      </>
                    ))}
                  </Box>

                {/* Requisitos técnicos */}
                <Box display={'flex'} flexDirection={'column'} border={'2px solid var(--chakra-colors-gray-400)'} w={'1380px'} mt={8}>
                  <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'}>
                    <Heading size={'md'}>Requisitos técnicos desejáveis</Heading>
                  </Box>
                  {Cargo && Object.entries(Cargo.niveis).map(([nivelNome, nivel]) => (
                    <>
                      <Flex flexDir="column">
                        <Box display={'flex'} flexDirection={'row'} border={'1px solid var(--chakra-colors-gray-400)'} w={'1378px'}>
                          <Text fontWeight="medium" display={'flex'} alignItems={'center'} backgroundColor={'gray.200'} maxWidth={'112px'} w={'112px'} p={4} justifyContent={'center'}>{nivelNome}</Text>
                          <Box w={'100%'} gap={'8px'} display={'flex'} flexDirection={'column'} p={4}>
                          {nivel.conhecimentosTecnicos.map((con, idx) => (
                            <InputCmp
                            key={idx}
                            value={con}
                            OnChange={(val) => {
                              const novos = [...nivel.conhecimentosTecnicos]
                              novos[idx] = val
                              setCargo({
                                ...Cargo,
                                niveis: {
                                  ...Cargo.niveis,
                                  [nivelNome]: { ...nivel, conhecimentosTecnicos: novos }
                                }
                              })
                            }}
                            OnRemove={
                                nivel.conhecimentosTecnicos.length > 1
                                  ? () => {
                                      OpenModalExclusaoByRequisitosTecnicos(nivel, nivelNome, idx)
                                    }
                                  : undefined
                                }
                                />
                          ))}
                                  <ButtonCmp
                                    OutlineColor="Green2"
                                    leftIcon={<FaPlus />}
                                    w="16rem"
                                    onClick={() => {
                                      setCargo({
                                        ...Cargo,
                                        niveis: {
                                          ...Cargo.niveis,
                                          [nivelNome]: {
                                            ...nivel,
                                            conhecimentosTecnicos: [...nivel.conhecimentosTecnicos, '']
                                          }
                                        }
                                      })
                                    }}
                                  >
                                    Adicionar Conhecimento
                                  </ButtonCmp>
                            </Box>
                          </Box>
                        </Flex>
                      </>
                  ))}
                </Box>

                {/* Competencias */}
                <Flex flexDir="column" gap="1rem" w={'1380px'} border={'2px solid var(--chakra-colors-gray-400)'} boxShadow={'var(--SombraBackground)'} mt={8}>
                      <Flex flexDir="column" gap="8px">
                              <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'}>
                                <Heading size={'md'}>Requisitos comportamentais desejáveis</Heading>
                              </Box>
                              <Flex p={'1rem'} gap={'8px'} flexDirection={'column'}>
                                {Cargo?.competenciasComportamentais?.map((value, i) => (
                                  <InputCmp
                                    key={i}
                                    value={value}
                                    OnChange={(val) => {
                                      const novos = [...Cargo.competenciasComportamentais]
                                      novos[i] = val
                                      setCargo({
                                        ...Cargo,
                                        competenciasComportamentais: novos
                                      })
                                    }}
                                    OnRemove={
                                      Cargo.competenciasComportamentais.length > 1
                                        ? () => {
                                            OpenModalExclusao(i)
                                          }
                                        : undefined
                                        }
                                  />
                                ))}
                                <ButtonCmp
                                  OutlineColor="Green2"
                                  leftIcon={<FaPlus />}
                                  w="16rem"
                                  onClick={() => {
                                    setCargo(prev => {
                                      if (!prev) return prev
                                      return {
                                        ...prev,
                                        competenciasComportamentais: [...Cargo?.competenciasComportamentais ?? [], '']
                                      }
                                    })
                                  }}
                                  >
                                  Adicionar Competência
                                </ButtonCmp>
                              </Flex>
                            </Flex>
                  </Flex>

                  </>
                )}
                {/* Criterios */}
            {Criterios && Cargo?.niveis && (
              <Flex flexDir="column" gap="1rem" w={'1380px'} border={'2px solid var(--chakra-colors-gray-400)'} boxShadow={'var(--SombraBackground)'} p={''} mt={8}>
                      <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'} >
                        <Heading size={'md'}>Critérios</Heading>
                      </Box>

                      <Flex borderRadius=".25rem" direction="column" border={'1px solid var(--c6)'}boxShadow={'var(--SombraBackground)'} fontSize={'15px'}>
                        <Grid gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`} alignItems={'center'} gap={'1rem'} px="1rem" py=".75rem" borderBottom="1px solid var(--c5)" w={'100%'} fontWeight="700" color={'var(--Gray3)'}>
                          <Flex>Competências</Flex>
                          {Object.keys(Cargo.niveis).map(nivelKey => (
                            <Flex key={nivelKey} flex="1" justify="center">{nivelKey.includes('_') ? nivelKey.replaceAll('_', ' ') : nivelKey}</Flex>
                          ))}
                        </Grid>

                     {Criterios.flatMap((criterio, i) => {
                       const criteriosParaExibir: Array<{ id: string, nome: string, niveis: NivelCriterioResponse[], minimo: boolean }> = [
                         {
                           id: criterio.id,
                           nome: `${criterio.nomeCriterio}${(criterio.niveisMinimos && criterio.niveisMinimos.length > 0) ? ' - Desejável' : ''}`,
                           niveis: criterio.niveis,
                           minimo: false
                         }
                       ]

                       if (criterio.niveisMinimos && criterio.niveisMinimos.length > 0) {
                         criteriosParaExibir.push({
                           id: criterio.id,
                           nome: `${criterio.nomeCriterio} - Mínimo`,
                           niveis: criterio.niveisMinimos,
                           minimo: true
                         })
                       }
                       return criteriosParaExibir.map((crit, j) => (
                        <Grid
                          key={`${crit.id}-${crit.nome}`}
                          gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`}
                          alignItems="center"
                          gap="1rem"
                          px="1rem"
                          py=".5rem"
                          w="100%"
                          bg={(i + j) % 2 === 0 ? 'var(--c2)' : ''}
                        >
                          <Flex fontWeight="600">{crit.nome}</Flex>

                          {Object.entries(Cargo.niveis).map(([nivelKey, nivel]) => {
                            const lista = nivel.criteriosPontuacao
                            const criterioSelecionado = lista?.find(cp => cp.criterioId === crit.id && crit.minimo === (cp.minimo === true))
                            const opcaoSelecionada = crit.niveis.find(n => n.id === criterioSelecionado?.opcaoPontuacaoId)

                            return (
                              <Flex key={nivelKey} flex="1" title={opcaoSelecionada ? `${opcaoSelecionada.pontuacao} - ${opcaoSelecionada.nome}` : undefined}>
                                <SelectCmp
                                  somenteLeitura={!isEditing}
                                  w="100%"
                                  placeholder="Selecionar opção"
                                  value={criterioSelecionado?.opcaoPontuacaoId ?? ''}
                                  OnChange={(opcaoId) => {
                                    const novosNiveis = { ...Cargo.niveis }
                                    const listaAtual = [...(novosNiveis[nivelKey].criteriosPontuacao)]
                                    const idx = listaAtual.findIndex(cp => cp.criterioId === crit.id && crit.minimo === (cp.minimo === true))
                                    if (idx >= 0) {
                                      listaAtual[idx].opcaoPontuacaoId = opcaoId
                                    } else {
                                      listaAtual.push({
                                        criterioId: crit.id,
                                        opcaoPontuacaoId: opcaoId,
                                        minimo: crit.minimo
                                      })
                                    }

                                    novosNiveis[nivelKey] = {
                                      ...novosNiveis[nivelKey], criteriosPontuacao: listaAtual
                                    }

                                    setCargo({
                                      ...Cargo,
                                      niveis: novosNiveis
                                    })

                                    // setMudancasFeitas(true)
                                  }}
                                >
                                  <option value={''} disabled>Selecione uma opção</option>
                                  {crit.niveis.sort((a, b) => b.pontuacao - a.pontuacao).map(n => (
                                    <option key={n.id} value={n.id}>
                                      {n.pontuacao} - {n.nome}
                                    </option>
                                  ))}
                                </SelectCmp>
                              </Flex>
                            )
                          })}
                        </Grid>
                       ))
                     })}

                        <Grid gridTemplateColumns={`1.25fr ${Object.entries(Cargo.niveis).map(() => '1fr').join(' ')}`} alignItems={'center'} gap={'1rem'} borderTop="1px solid var(--c5)" px="1rem" py=".75rem" fontWeight="600">
                          <Flex flex="2">Pontuação Total</Flex>
                          {Object.entries(Cargo.niveis).map(([nivelKey, nivel]) => {
                            const total = (nivel.criteriosPontuacao ?? [])
                              .map(cp => {
                                const criterio = Criterios.find(c => c.id === cp.criterioId)
                                const opcao = criterio?.niveis.find(n => n.id === cp.opcaoPontuacaoId)
                                if (criterio?.nivelMinimo && !cp.minimo) return 0
                                return opcao?.pontuacao ?? 0
                              })
                              .reduce((acc, val) => acc + val, 0)

                            return (
                              <Flex key={nivelKey} flex="1" justify="center" fontWeight="700">{total}</Flex>
                            )
                          })}
                        </Grid>
                      </Flex>
                    </Flex>
            )}
            {isEditing && (
              <Box display="flex" flexDirection="column" mt="1.5rem" w="1380px">
                <Text>Escreva suas observações:</Text>

                <Textarea
                  border="2px solid"
                  borderColor="gray.500"
                  value={
                    Cargo?.solicitacaoReajustes?.length
                      ? Cargo.solicitacaoReajustes[
                        Cargo.solicitacaoReajustes.length - 1
                      ].observacoes ?? ''
                      : ''
                  }
                  onChange={(e) => alterarObservacoesUltimaSolicitacao(e.target.value)}
                />
              </Box>
            )}

            <Box display={'flex'} flexDirection={'row'} width={'100%'} justifyContent={'right'} h={'50px'} gap={4} pr={8} pt={5} marginRight={'29rem'}>
                {isEditing
                  ? (
                  <>
                  <ChakraButton
                      borderRadius={'.25rem'}
                      filter='auto'
                      h={'40px'}
                      fontSize={'14px'}
                      py={'.125rem'}
                      px={'.75rem'}
                      color={'white'}
                      border={'1px solid var(--chakra-colors-pink-200)'}
                      _hover={{
                        bg: 'var(--chakra-colors-pink-200)',
                        boxShadow: 'var(--SombraBtns)',
                        color: 'var(--c1)',
                        transition: 'var(--transitionBtns);'
                      }}
                      bg={'gray.500'}
                      leftIcon={<MdBlock size={20} />}
                      onClick={() => cancelarAjustes()}
                      >Cancelar ajustes</ChakraButton>
                  <ChakraButton
                      borderRadius={'.25rem'}
                      filter='auto'
                      h={'40px'}
                      fontSize={'14px'}
                      py={'.125rem'}
                      px={'.75rem'}
                      color={'white'}
                      border={'1px solid var(--chakra-colors-pink-200)'}
                      _hover={{
                        bg: 'var(--chakra-colors-pink-200)',
                        boxShadow: 'var(--SombraBtns)',
                        color: 'var(--c1)',
                        transition: 'var(--transitionBtns);'
                      }}
                      bg={'green.400'}
                      leftIcon={<BiSolidPaperPlane size={20} />}
                      isLoading={isSubmittingAjuste}
                      isDisabled={isSubmittingAjuste}
                      onClick={() => onSolicitarReajuste()}
                      >Enviar ajustes e observações</ChakraButton>
                  </>
                    )
                  : (
                    <>
                    <ChakraButton
                    borderRadius={'.25rem'}
                    filter='auto'
                    h={'40px'}
                    fontSize={'14px'}
                    py={'.125rem'}
                    px={'.75rem'}
                    color={'pink.200'}
                    border={'1px solid var(--chakra-colors-pink-200)'}
                    _hover={{
                      bg: 'var(--chakra-colors-pink-200)',
                      boxShadow: 'var(--SombraBtns)',
                      color: 'var(--c1)',
                      transition: 'var(--transitionBtns);'
                    }}
                    bg={'white'}
                    leftIcon={<MdOutlinePictureAsPdf size={20} />}
                    onClick={() => setBaixarRelatorio(true)}
                    >Gerar PDF</ChakraButton>

                    <ChakraButton
                    borderRadius={'.25rem'}
                    filter='auto'
                    h={'40px'}
                    fontSize={'14px'}
                    py={'.125rem'}
                    px={'.75rem'}
                    color={'pink.200'}
                    border={'1px solid var(--chakra-colors-pink-200)'}
                    _hover={{
                      bg: 'var(--chakra-colors-pink-200)',
                      boxShadow: 'var(--SombraBtns)',
                      color: 'var(--c1)',
                      transition: 'var(--transitionBtns);'
                    }}
                    bg={'white'}
                    leftIcon={<HiOutlinePencilSquare size={20} />}
                    onClick={() => editarDoc()}
                    >Solicitar ajustes no documento</ChakraButton>

                    <ChakraButton
                        borderRadius={'.25rem'}
                        filter='auto'
                        h={'40px'}
                        fontSize={'14px'}
                        py={'.125rem'}
                        px={'.75rem'}
                        color={'white'}
                        border={'1px solid var(--chakra-colors-pink-200)'}
                        _hover={{
                          bg: 'var(--chakra-colors-pink-200)',
                          boxShadow: 'var(--SombraBtns)',
                          color: 'var(--c1)',
                          transition: 'var(--transitionBtns);'
                        }}
                        bg={'green.400'}
                        leftIcon={<FaFileSignature size={20} />}
                        onClick={onOpen}
                        >Assinar documento</ChakraButton>

                    </>
                    )}
            </Box>
            <ModalAssinarDocumento onClose={onClose} isOpen={isOpen} setDadosAssinante={setDadosAssinante} dadosAssinante={dadosAssinante} />
            <ModalExcluirCompetencia onClose={modalB.onClose} isOpen={modalB.isOpen} excluirCompentencia={excluirCompetencia} indiceDoExcluido={indiceDoExcluido ?? 999}/>
            <ModalExcluirAtribuicao onClose={modalC.onClose} isOpen={modalC.isOpen} excluirCompentencia={excluirAtribuicao} indiceDoExcluido={indiceDoExcluido ?? 999} nivel={nivelDoExcluido} nivelNome={nomeExcluido}/>
            <ModalExcluirAtribuicao onClose={modalD.onClose} isOpen={modalD.isOpen} excluirCompentencia={excluirRequisitoTecnico} indiceDoExcluido={indiceDoExcluido ?? 999} nivel={nivelDoExcluido} nivelNome={nomeExcluido}/>
            <ModalExcluirCargoSupOuSub onClose={modalE.onClose} isOpen={modalE.isOpen} removerCargo={removeCargoSup} index={indexDoCargoExcluido}/>
            <ModalExcluirCargoSupOuSub onClose={modalF.onClose} isOpen={modalF.isOpen} removerCargo={removeTrilha} index={indexDoCargoExcluido}/>

        </Flex>
  )
}
